module.exports = __webpack_public_path__ + "media/hind/Hind-SemiBold-f314c7e9.woff2";